/**
 * @import { BBox } from 'geojson'
 */

/** @type {BBox} */
export const globalBbox = [-180, -90, 180, 90];

/**
 * @param {google.maps.LatLngBounds | undefined} bounds
 * @param {number} [paddingDegrees]
 * @returns {BBox}
 */
export function boundsToBBox(bounds, paddingDegrees = 0) {
  if (!bounds) {
    return globalBbox;
  }

  const southWest = bounds.getSouthWest();
  const northEast = bounds.getNorthEast();
  const west = southWest.lng();
  const east = northEast.lng();

  // Low zoom levels can wrap around the 180° meridian and result in the west longitude > east longitude.
  // While it works for Google Maps, it produces an invalid bounding box.  When that occurs, at this scale
  // it's simpler to just use the global bounding box.
  if (west > east) {
    return globalBbox;
  }

  const northPadded = Math.min(90, northEast.lat() + paddingDegrees);
  const southPadded = Math.max(-90, southWest.lat() - paddingDegrees);
  const westPadded = Math.max(-180, west - paddingDegrees);
  const eastPadded = Math.min(180, east + paddingDegrees);

  return [westPadded, southPadded, eastPadded, northPadded];
}
